import React from 'react';

export const PlusWhiteIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 3C11.5 2.44772 11.0523 2 10.5 2C9.94772 2 9.5 2.44772 9.5 3V9H3.5C2.94772 9 2.5 9.44772 2.5 10C2.5 10.5523 2.94772 11 3.5 11H9.5V17C9.5 17.5523 9.94772 18 10.5 18C11.0523 18 11.5 17.5523 11.5 17V11H17.5C18.0523 11 18.5 10.5523 18.5 10C18.5 9.44772 18.0523 9 17.5 9H11.5V3Z"
        fill="white"
      />
    </svg>
  );
};
